import React from "react";

// Material UI imports
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";

// Styling
import "./style.scss";

const AddClassFormHeader = ({ state }) => {
  return (
    <>
      <div className="__addClassFormHeader">
        <h1
          className={
            state.theme === "dark"
              ? " __schemaAddClassPageHeaderDark"
              : " __schemaAddClassPageHeaderLight"
          }
        >
          New Schema Class
        </h1>

        <Tooltip
          title="A class describes a data entity, in the form of a singular noun (for things) or verb (for actions). Once a class is added, it becomes immutable, but extendable."
          placement="right-start"
        >
          <HelpIcon
            style={{
              color: state.theme === "dark" ? "#848484" : "#5e5e5e",
              cursor: "pointer",
              marginBottom: "3px",
            }}
          />
        </Tooltip>
      </div>
    </>
  );
};

export default AddClassFormHeader;
